<template>
    <div class="banner-app">
        <div class="banner-app__inner">
            <div class="banner-app__background">
                <v-lazy-image :src="require('@/assets/img/bg-download.jpg')"></v-lazy-image>
            </div>
            <div class="banner-app__content">
                <div class="banner-app__content__image">
                    <v-lazy-image :src="require('@/assets/img/phone-watch.png')"></v-lazy-image>
                </div>
                <div class="banner-app__content__text">
                    <div class="h3" v-translate>banner_app_title</div>
                    <div class="text" v-translate>banner_app_text</div>
                    <div class="banner-app__buttons">
                        <a href="https://apps.apple.com/us/app/pumatrac-training-running/id698298978" target="_blank" @click.prevent="downloadLinkClick('https://apps.apple.com/us/app/pumatrac-training-running/id698298978', 'apple')">
                            <v-lazy-image :src="require('@/assets/img/appstore.svg')"></v-lazy-image>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.pumapumatrac" target="_blank" @click.prevent="downloadLinkClick('https://play.google.com/store/apps/details?id=com.pumapumatrac', 'android')">
                            <v-lazy-image :src="require('@/assets/img/play-store.svg')"></v-lazy-image>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { captureOutboundLink } from "@/utils/tracking"

export default {
    methods: {
        downloadLinkClick(url, type) {
            captureOutboundLink(url, {navigation: {subSection: "home", screenName: "opportunities"}, event: {type: "download", value: `web_download_${type}`}})
        }
    }
}
</script>


<style lang="scss" scoped>
.banner-app {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 6px;

    &__inner {
        position: relative;
        height: 100%;
    }

    &__background {
        @include fillout;
        
        img {
            @include object-fit;
        }
    }

    &__content {
        position: relative;
        display: flex;
        align-items: center;
        padding: 20px 70px;
        height: 100%;

        @include mq($until: notebook) {
            padding: 20px 40px;
        }

        @include mq($until: mobile-landscape) {
            flex-direction: column;
            padding: 20px;
        }

        &__image {
            img {
                width: 138px;

                @include mq($until: desktop) {
                    width: 100px;
                }
            }
        }

        &__text {
            color: white;
            padding-left: 34px;

            @include mq($until: mobile-landscape) {
                padding: 0;
            }
        }
    }

    &__buttons {
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
        line-height: 1;

        & > * {
            margin: 0 10px 6px 0;

            img {
                height: 40px;
            }
        }
    }
}
</style>